// extracted by mini-css-extract-plugin
module.exports = {"hiddenEventsCount":"HiddenDays_hiddenEventsCount__22LZz","events":"HiddenDays_events__3hZva","hiddenDaysWrapper":"HiddenDays_hiddenDaysWrapper__1FCS4"};